// 页面路由
import Vue from "vue";
import Router from "vue-router";
// 引入路由组件 按需加载
const toShopping = () => import("../views/toShopping/toShopping.vue");
const advertising = () => import("../views/advertising/advertising.vue");
const advertising2 = () => import("../views/advertising/advertising2.vue");

const OnfirmOrder = () => import("../views/ConfirmOrder/onfirmOrder.vue");
const BuyCart = () => import("../views/buyCart/buyCart.vue");
const EvaluationDetails = () =>
  import("../views/evaluationDetails/evaluationDetails.vue");
const Recommend = () => import("../views/Recommend/recommend.vue");
const Refund = () => import("../views/Refund/refund.vue");
const Address = () => import("../views/Address/address.vue");
const editAddress = () => import("../views/Address/editAddress.vue");
const addToAddress = () => import("../views/Address/addToAddress.vue");
const ServiceEvaluation = () =>
  import("../views/serviceEvaluation/serviceEvaluation.vue");
const OrderToBePaid = () => import("../views/OrderDetailed/OrderToBePaid.vue");
const MyOrder2 = () => import("../views/MyOrder/myOrder2.vue");
const PersonalCenter = () =>
  import("../views/PersonalCenter/personalCenter.vue");
const Payment = () => import("../views/Payment/payment.vue");
const PaymentResult = () => import("../views/PaymentResult/paymentResult.vue");
const Sevaluation = () => import("../views/PaymentResult/Sevaluation.vue");
//评价详细
const Particular = () => import("../views/serviceEvaluation/particular.vue");
// 客服
const Service = () => import("../views/Serviceman/service.vue");
// 确认收货页面
const ConfirmReceivingGoods = () =>
  import("../views/OrderDetailed/ConfirmReceivingGoods.vue");
// 待发货页面
const DeliverGoods = () => import("../views/OrderDetailed/DeliverGoods.vue");
// 待收货页面
const ReceivingGoods = () =>
  import("../views/OrderDetailed/ReceivingGoods.vue");
// 售后退货
const Logistics = () => import("../views/Logistics/logistics.vue");
const EvaluationCenter = () =>
  import("../views/serviceEvaluation/evaluationCenter.vue");
const AfterSale = () => import("../views/Refund/AfterSale.vue");
const ReturnAudit = () => import("../views/ReturnAudit/ReturnAudit.vue");
const ReturnDetails = () => import("../views/ReturnAudit/ReturnDetails.vue");
const FillLogistics = () => import("../views/FillLogistics/FillLogistics.vue");
const AfteProcessStatus = () =>
  import("../views/Logistics/AfteProcessStatus.vue");
const Search = () => import("../views/Search/search.vue");
const orderAddress = () => import("../views/Address/orderAddress.vue");
const orderEditAddress = () => import("../views/Address/orderEditAddress.vue");
const AfterList = () => import("../views/Refund/AfterList.vue");
const Bill = () => import("../views/bill/index.vue");
const Discover = () => import("../views/discover/index.vue");
const DiscoverClid = () => import("../views/discover/discoverClid.vue");
// 安装路由
Vue.use(Router);

const router = new Router({
  mode: "history",
  // 配置页面的路由
  routes: [
    {
      path: "/",
      // component: Index,
      component: (r) =>
        require.ensure(
          [],
          () => r(require("../views/Index/index.vue")),
          "index"
        ),
      redirect: "/index",
    },
    {
      // 首页
      path: "/index",
      // component: Index,
      component: (r) =>
        require.ensure(
          [],
          () => r(require("../views/Index/index.vue")),
          "index"
        ),
      meta: {
        keepAlive: true, //此组件需要被缓存
        isBack: false, //用于判断上一个页面是哪个
      },
    },
    {
      // 商品详情
      path: "/toShopping",
      component: toShopping,
    },
    {
      // 商品详情
      path: "/discover",
      name:'Discover',
      component: Discover,
      children: [],
    },
    {
      path: "/discoverClid",
      component: DiscoverClid,
    },
    {
      // 商品详情
      path: "/advertising/:id",
      component: advertising,
    },
    {
      // 商品详情
      path: "/advertising2/:id",
      component: advertising2,
    },
    {
      // 支付页面
      path: "/payment",
      component: Payment,
    },
    {
      // 支付页面
      path: "/bill",
      component: Bill,
    },
    {
      // 支付结果
      path: "/paymentResult",
      component: PaymentResult,
    },
    // 评价结果
    {
      path: "/Sevaluation",
      component: Sevaluation,
    },
    {
      // 确认订单
      path: "/onfirmOrder",
      name: "onfirmOrder",
      component: OnfirmOrder,
      meta: {
        keepAlive: true,
      },
    },
    {
      // 购物车
      path: "/buyCart",
      component: BuyCart,
    },
    {
      // 商品、详细、评价、推荐
      path: "/evaluationDetails",
      component: EvaluationDetails,
    },
    {
      // 新品推荐
      path: "/recommend",
      component: Recommend,
    },
    {
      // 售后退款
      path: "/refund",
      component: Refund,
    },
    {
      // 地址列表
      path: "/address",
      component: Address,
    },
    {
      // 修改地址
      path: "/editAddress",
      component: editAddress,
    },
    {
      // 添加地址
      path: "/addToAddress",
      component: addToAddress,
    },
    {
      // 售后评价
      path: "/serviceEvaluation",
      component: ServiceEvaluation,
    },
    {
      // 待支付详情
      path: "/OrderToBePaid",
      component: OrderToBePaid,
    },
    {
      // 我的订单
      path: "/myOrder2",
      component: MyOrder2,
    },
    {
      // 个人中心
      path: "/personalCenter",
      component: PersonalCenter,
    },
    {
      // 确认收货
      path: "/ConfirmReceivingGoods",
      component: ConfirmReceivingGoods,
    },
    {
      // 待发货详细
      path: "/DeliverGoods",
      component: DeliverGoods,
    },
    {
      // 待收货详细
      path: "/ReceivingGoods",
      component: ReceivingGoods,
    },
    {
      // 查看物流
      path: "/Logistics",
      component: Logistics,
    },
    {
      // 填写物流单号页面
      path: "/FillLogistics",
      component: FillLogistics,
    },
    {
      // 填写售后状态流程页面
      path: "/AfteProcessStatus",
      component: AfteProcessStatus,
    },
    {
      // 评价中心
      path: "/evaluationCenter",
      component: EvaluationCenter,
    },
    // 评价详细
    {
      path: "/particular",
      component: Particular,
    },
    // 客服
    {
      path: "/service",
      component: Service,
    },
    {
      // 申请售后
      path: "/AfterSale",
      name: "AfterSale",
      component: AfterSale,
    },
    {
      // 退货审核
      path: "/returnAudit",
      component: ReturnAudit,
    },
    {
      // 退货详情
      path: "/returnDetails",
      component: ReturnDetails,
    },
    {
      // 退货列表详情
      path: "/AfterList",
      component: AfterList,
    },
    {
      // 搜索页面
      path: "/search",
      component: Search,
    },
    {
      // 确认订单的修改地址页面
      path: "/orderAddress",
      name: "OrderAddress",
      component: orderAddress,
    },
    {
      // 确认订单的修改地址页面
      path: "/orderEditAddress",
      component: orderEditAddress,
    },
  ],
  // 跳转回到顶部
  scrollBehavior() {
    return new Promise((resolve, reject) => {
      setTimeout(() => {
        resolve({ x: 0, y: 1 }); // 和 window.scrollTo 类似
      }, 0);
    });
  },
});

export default router;
